import React from "react";
import useProducers from "../../../../hooks/useProducers/useProducers";
import Control from "../../../common/Controls/Control";
import useLeadFilters from "./useLeadFilters";

const ProducerSelect = ({
  commonControlProps,
  bare = false,
  selectClassName = "",
}) => {
  const { leadsFilters, setLeadsFilters } = useLeadFilters();
  const { producers } = useProducers(true);

  const onChangeProducer = (e) => {
    setLeadsFilters({
      ...leadsFilters,
      filters: {
        ...leadsFilters.filters,
        producer: e.target.value,
        assignedTo: [],
      },
    });
  };

  // Mode "bare" : <select> natif sans label (le label de section est géré par
  // le panneau). Évite le double-label de l'ancienne cartouche.
  if (bare) {
    return (
      <select
        className={selectClassName}
        name="producer"
        value={leadsFilters.filters.producer}
        onChange={onChangeProducer}
      >
        <option value="">Toutes les sociétés…</option>
        {producers.map((p) => (
          <option key={p.id} value={p.id}>
            {p.company}
          </option>
        ))}
      </select>
    );
  }

  return (
    <Control
      label="Société partenaire"
      name="producer"
      type="select"
      change={onChangeProducer}
      value={leadsFilters.filters.producer}
      datas={producers}
      dataIndex="id"
      dataLabel="company"
      {...commonControlProps}
    />
  );
};

export default ProducerSelect;
